import type { ImpactType } from './articles/data'
import translations from './impact-intros.translations'
import type { I18nDescriptor } from './metals/types'

export interface ImpactIntro {
  title: I18nDescriptor
  description: I18nDescriptor
  /** Still the gallery shows while the entry sits idle (`<video poster>`). */
  poster: string
}

// The video is named after the record key (`environmental_<locale>.mp4`), so it needs no
// field; the still does, being art rather than a derivable name.
export const IMPACT_INTROS: Record<ImpactType, ImpactIntro> = {
  environmental: {
    title: translations.environmentalTitle,
    description: translations.environmentalDescription,
    poster: '/mine-my-phone/images/posters/environmental.jpg',
  },
  human: {
    title: translations.humanTitle,
    description: translations.humanDescription,
    poster: '/mine-my-phone/images/posters/human.jpg',
  },
  geopolitical: {
    title: translations.geopoliticalTitle,
    description: translations.geopoliticalDescription,
    poster: '/mine-my-phone/images/posters/geopolitical.jpg',
  },
}
